import Mobile from '../mobile/index';
import {mapActions} from 'vuex';

export const isMobile = {
  methods: {
    ...mapActions('mobile', [
      'setIsMobile',
    ]),
    initIsMobile: async function() {
      let win = window.innerWidth;
      let isMobile = (win < 768);

      this.setIsMobile(isMobile);
    },
  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/isMobile.js